import sliceCreator from '../../index.js';
import {EDIT_REPORT} from '../../../constants/index.js';
const _editDamageReportAction = sliceCreator('EDIT_REPORT',EDIT_REPORT, 'put');

const { asyncAction: editDamageReportAction, reducer, clearData: clearEditDamageReportAction } = _editDamageReportAction;

export default reducer;

export {
    editDamageReportAction,
    clearEditDamageReportAction
}


